import responsiveAlignment from './responsiveAlignment';
import merge from 'lodash/merge';

const options = {
  responsiveAlignment: true,
};
export default function baseStyles(
  {alignment = {}, hideOn = []},
  settings = {},
) {
  let jss = {};

  settings = {...options, ...settings};

  if (settings.responsiveAlignment) {
    jss = responsiveAlignment(alignment);
  }

  /* If SSR */

  const SHOW_SELECTOR = '&:not(.element-show)';

  if (typeof window === 'undefined') {
    if (hideOn.includes('desktop')) {
      merge(jss, {
        '@media only screen and (min-width: 768px)': {
          [SHOW_SELECTOR]: {
            display: 'none !important',
          },
        },
      });
    }

    if (hideOn.includes('tablet')) {
      merge(jss, {
        '@media screen and (max-width: 768px) and (min-width: 576px)': {
          [SHOW_SELECTOR]: {
            display: 'none !important',
          },
        },
      });
    }

    if (hideOn.includes('mobile')) {
      merge(jss, {
        '@media screen and (max-width: 576px)': {
          [SHOW_SELECTOR]: {
            display: 'none !important',
          },
        },
      });
    }
  }

  return jss;
}
